import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { Camera } from "./../../compoment/icon";
import { getPortraitViewportContainer } from "../../compoment/PortraitStage";
import { clearTicketDetailFromStorage } from "../../utils/ticket";

const IdleScreen = () => {
  const navigate = useNavigate();
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    clearTicketDetailFromStorage();
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    video.play().catch(() => {
      // The browser can interrupt play() during fast route changes in dev.
    });

    return () => {
      video.pause();
    };
  }, []);

  const handleScanNow = () => {
    navigate("/qr-scan", { replace: true, state: { rescan: Date.now() } });
  };

  return (
    <>
      <section className="idleSection">
        {createPortal(
          <div className="fullScreenVideo">
            <video
              ref={videoRef}
              className="backgroundVideo"
              loop
              muted
              playsInline
            >
              <source
                src="https://d2s4ngnid78ki4.cloudfront.net/assets/bg-vedio.mp4"
                type="video/mp4"
              />
            </video>
            <div className="overlay" />
          </div>,
          getPortraitViewportContainer() ?? document.body
        )}

        <div className="d-flex justify-content-center h-100 flex-column" style={{ width: "100%" }}>
          <div className="scanCard mx-auto text-center">
            <div className="heading">Release Room</div>
            <div className="tapTxt">
              Tap{" "}
              <span className="scanNow">
                <Camera /> Scan QR Code
              </span>{" "}
              to use the kiosk
            </div>

            <button className="btnScanNow mt-3" onClick={handleScanNow}>
              <span>
                <Camera />
              </span>{" "}
              Scan QR Code
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default IdleScreen;
